import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

const updateEndpoint = `${apiUrl}updateLeaderboardVisibility/`;
const fetchEndpoint = `${apiUrl}fetchLeaderboardVisibility/`;

export interface UpdateLeaderboardVisibilityRequest {
  OrgUUID: string;
  LeaderboardEnabled: boolean;
}

export interface UpdateLeaderboardVisibilityResponse {
  Error: string | null;
}

export interface FetchLeaderboardVisibilityRequest {
  OrgUUID: string;
}

export interface FetchLeaderboardVisibilityResponse {
  LeaderboardEnabled: boolean;
  Error: string | null;
}

export async function updateLeaderboardVisibility(
  req: UpdateLeaderboardVisibilityRequest
): Promise<UpdateLeaderboardVisibilityResponse> {
  try {
    const res = await postWithAuth(updateEndpoint, {
      OrgUUID: req.OrgUUID,
      LeaderboardEnabled: req.LeaderboardEnabled,
    });
    if (!res.ok) {
      const err = (await res.json().catch(() => null)) as {
        error?: string;
      } | null;
      return { Error: err?.error ?? `HTTP ${res.status}` };
    }
    const data = (await res
      .json()
      .catch(() => null)) as UpdateLeaderboardVisibilityResponse | null;
    return { Error: data?.Error ?? null };
  } catch (e) {
    return { Error: e instanceof Error ? e.message : 'Network error' };
  }
}

export async function fetchLeaderboardVisibility(
  req: FetchLeaderboardVisibilityRequest
): Promise<FetchLeaderboardVisibilityResponse> {
  try {
    const res = await postWithAuth(fetchEndpoint, { OrgUUID: req.OrgUUID });
    if (!res.ok) {
      const err = (await res.json().catch(() => null)) as {
        error?: string;
      } | null;
      return {
        LeaderboardEnabled: true,
        Error: err?.error ?? `HTTP ${res.status}`,
      };
    }
    const data = (await res
      .json()
      .catch(() => null)) as FetchLeaderboardVisibilityResponse | null;
    if (!data || typeof data !== 'object' || !('LeaderboardEnabled' in data)) {
      return { LeaderboardEnabled: true, Error: 'Invalid server response' };
    }
    return {
      LeaderboardEnabled: data.LeaderboardEnabled ?? true,
      Error: data.Error ?? null,
    };
  } catch (e) {
    return {
      LeaderboardEnabled: true,
      Error: e instanceof Error ? e.message : 'Network error',
    };
  }
}
